import script from "./HandoverUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./HandoverUpload.vue?vue&type=script&setup=true&lang=js"

import "./HandoverUpload.vue?vue&type=style&index=0&id=440d9858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440d9858"]])

export default __exports__